module.exports = __webpack_public_path__ + "media/images/sp/brands/common/brand_menu_campaigns-9d3e25b7a137e754986c6935487d94b0.webp";